import {defineStore} from "pinia";
import {Ref, ref} from "vue";
import {IPanel} from "@/features/chat/chat.types";
import {ITableHeader} from "@/types/table";
import {IFilter, IFilterPanel} from "@/types/main";
import {messageService} from "@/features/message/message.service";
import {DateTime} from "luxon";

export const useMessageStore = defineStore("message", () => {
    const headers: ITableHeader[] = [
        {
            name: "id",
            label: "No",
            width: '10px'
        },
        {
            name: "sender_name",
            label: "Sender",
            width: '300px'
        },
        {
            name: "receiver_name",
            label: "Receiver",
            width: '300px'
        },
        {
            name: "shift_name",
            label: "Shift",
        },
        {
            name: "activity_time",
            label: "Date",
            width: '120px'
        },
        {
            name: "reply_time_seconds",
            label: "Reply time",
            width: '110px'
        },
        {
            name: "from",
            label: "From",
        },
        {
            name: "text",
            label: "Message",
            width: '600px'
        },
        {
            name: "save",
            label: "Save",
        },
    ];

    const panels = ref<IPanel>({
        allMessages: true,
        text: false,
        call: false,
        voice: false,
        photo: false,
        allErrors: false,
        replyTime: false,
        unanswered: false,
        deleted: false,
        edited: false,
    });


    const today = new Date()
    const yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)

    const commonFilter = ref<IFilter>({
        q: '',
        date_from: datepickerToUtcDateOnly(new Date(yesterday)),
        date_to: datepickerToUtcDateOnly(new Date(today)),
        time_from: '',
        time_to: '',
        shift_id: 0,
        account: 0,
        outgoing: null,
        fuzzy: true,
        fuzzy_threshold: 0.3,
        page: 1,
        page_size: 50,
        include_photo_base64: false,
    })

    const additionalFilter = ref<IFilterPanel>({
        messages_text: null,
        messages_photo: null,
        messages_video: null,
        messages_voice: null,
        messages_round: null,
        messages_audio: null,
        messages_document: null,

        is_deleted: null,
        is_edited: null,
        missed_call: null,
        declined_call: null,
        reply_time_exceed: null,
        calls: null
    })

    async function getMessages(loading: Ref) {
        try {
            loading.value = true
            let newFilter = {...commonFilter.value, ...additionalFilter.value};
            if (newFilter.q.length == 0) {
                delete newFilter.fuzzy
                delete newFilter.fuzzy_threshold
            }
            const {data} = await messageService.getMessages(newFilter);
            return data
        } finally {
            loading.value = false
        }
    }

    function datepickerToUtcDateOnly(d: Date | null | undefined) {
        if (!d) return ''
        const local = DateTime.fromJSDate(d)
        return DateTime.utc(local.year, local.month, local.day).toFormat('yyyy-MM-dd')
    }

    return {headers, panels, commonFilter, additionalFilter, getMessages};
});
